import React from "react";
import UserInfo from "./components/UserInfo";
import UserTasks from "./components/UserTasks/UserTasks";
import Support from "./components/Support";
//import { getTranslation as translate } from "logic/LocaleManager";

// Externals
import cn from "classnames";

// Component styles
import classes from "./Sidebar.module.scss";


function Sidebar(props) {

  return (
    <div className={cn(classes.sidebar, "dx-theme-background-color", "dx-theme-border-color")}>
      <div className={classes.top}>
        <UserInfo {...props} />
      </div>

      <div className={classes.middle}>
        <UserTasks {...props} />
      </div>

      <div className={classes.bottom}>
        <Support {...props} />
      </div>
    </div>
  );
}

export default (Sidebar);
